import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import InputFileChooseComponent from '../components/inputs/InputFileChooseComponent';
import MenuItemIcon from '../components/MenuItemIcon';
import OrderFuelService from '../services/OrderFuelService';

class OrderFuelConfirmationDialog extends BaseDialogContainer {
    constructor(props) {
        super(props);
        this.service = new OrderFuelService();
        this.state = {
            attachment: undefined,
            financialAuthSent: false,
            financialAuthCancelled: false,
            orderConfirmed: false,
        };
    }

    startRedirectCountdown() {
        const {backUrl} = this.props;
        setTimeout(() => {
            window.location.href = backUrl;
        }, 10000);
    }

    renderFooter() {
        const {t, backUrl, status, orderNumber} = this.props;
        const {attachment, financialAuthSent, financialAuthCancelled, orderConfirmed} = this.state;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('order-fuel.cancelOrder')}
                    variant='button save-button blue'
                    handleClick={() => {
                        this.blockUi();
                        this.service
                            .cancelOrder(orderNumber)
                            .then(() => {
                                this.setState({financialAuthCancelled: true}, () => this.unblockUi(() => this.startRedirectCountdown()));
                            })
                            .catch(() => {
                                this.showErrorMessage(t('order-fuel.cancelOrderError'));
                                this.unblockUi();
                            });
                    }}
                    rendered={status === 'ACTION_REQUIRED' && !financialAuthSent && !financialAuthCancelled && !orderConfirmed}
                />
                <ActionButton
                    label={
                        status === 'ACTION_REQUIRED' && !financialAuthSent && !financialAuthCancelled && !orderConfirmed
                            ? t('order-fuel.confirmOrder')
                            : t('details.close')
                    }
                    variant='button save-button blue'
                    handleClick={() => {
                        if (status === 'ACTION_REQUIRED' && !financialAuthSent && !financialAuthCancelled && !orderConfirmed) {
                            if (this.validator.allValid()) {
                                if (attachment !== undefined && attachment !== null) {
                                    this.blockUi();
                                    this.service
                                        .sendFinancialAuth(attachment, orderNumber)
                                        .then(() => {
                                            this.setState({financialAuthSent: true}, () =>
                                                this.unblockUi(() => this.startRedirectCountdown())
                                            );
                                        })
                                        .catch(() => {
                                            this.showErrorMessage(t('error.sendFinancialAuthError'));
                                            this.unblockUi();
                                        });
                                } else {
                                    this.setState({orderConfirmed: true}, () => this.unblockUi(() => this.startRedirectCountdown()));
                                }
                            } else {
                                this.validator.showMessages();
                                this.scrollToError = true;
                                this.forceUpdate();
                            }
                        } else {
                            window.location.href = backUrl;
                        }
                    }}
                />
            </div>
        );
    }

    renderHeader() {
        return null;
    }

    setElement() {
        this.initAfterSetElement();
    }

    initAfterSetElement() {
        super.initAfterSetElement();
        const {status} = this.props;
        if (!!status && status !== 'ACTION_REQUIRED') {
            this.startRedirectCountdown();
        }
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    renderDetails() {
        const {t, status, orderNumber, phoneNumber} = this.props;
        const {financialAuthSent, financialAuthCancelled, orderConfirmed} = this.state;
        return (
            <React.Fragment>
                {(status === 'SUCCESS' && !financialAuthSent) || (status === 'ACTION_REQUIRED' && orderConfirmed) ? (
                    <div>
                        <div className='row font-14-500'>
                            <div className='icon-text'>
                                <MenuItemIcon alt='' className='icon-svg left' iconSvg='ico_green_checkbox' />
                                {t('order-fuel.thanksForOrdering')}
                            </div>
                        </div>
                        <div className='col-12 font-14-500  order-number-row'>
                            <span className='flex-inputs'>{t('order-fuel.orderNumber')}</span>
                            <span className='flex-inputs bold'>{orderNumber}</span>
                        </div>
                        <div className='col-12 font-14-500 redirect'>
                            <span className='flex-inputs'>{t('order-fuel.redirect')}</span>
                        </div>
                    </div>
                ) : status === 'ACTION_REQUIRED' ? (
                    !financialAuthSent && !financialAuthCancelled ? (
                        <div>
                            <div className='header font-18-600'>{t('order-fuel.fuelOrder')}</div>
                            <div className='icon-text'>
                                <MenuItemIcon alt='' className='icon-svg left' iconSvg='ico_help_input_label_blue' />
                                <div className='order-fuel-financial-auth'>
                                    <div className='bold'>{t('order-fuel.financialAuth')}</div>
                                    <div dangerouslySetInnerHTML={{__html: t('order-fuel.[html]financialAuthDescr', {phoneNumber})}} />
                                </div>
                            </div>
                            <div className='tips'>
                                <span>{t('order-fuel.tips')}</span>
                                <ul>
                                    <li>{t('order-fuel.tips1')}</li>
                                    <li>{t('order-fuel.tips2')}</li>
                                </ul>
                            </div>
                            <InputFileChooseComponent
                                id='attachment'
                                name='attachment'
                                colClass='attachment col-width-auto'
                                multiple={false}
                                file={this.state.attachment}
                                showLabel={false}
                                viewMode='NEW'
                                label=''
                                onChange={this.handleChange}
                                validator={this.validator}
                                itemLabel='fileName'
                                maxFileSize={2000000}
                                maxFileCount={1}
                                validateViewMode
                                validators='not_required'
                                browseButton={
                                    !this.state.attachment ? (
                                        <div className='attachment-label-empty'>
                                            <img
                                                alt={t('order-card.uploadIconLabel')}
                                                src='/images/ico_drag_file.svg'
                                                className='attachment-label-icon'
                                            />
                                            <div className='attachment-label-text'>{t('order-card.uploadIconLabel')}</div>
                                        </div>
                                    ) : (
                                        <div className='attachment-label'></div>
                                    )
                                }
                                dragNdrop={true}
                                stateField=''
                                accepts={['.pdf']}
                            />
                        </div>
                    ) : (
                        <div>
                            <div className='row font-14-500'>
                                <div className='icon-text'>
                                    <MenuItemIcon
                                        alt=''
                                        className='icon-svg left'
                                        iconSvg={financialAuthCancelled ? 'ico_red_banner_alert_icon' : 'ico_green_checkbox'}
                                    />
                                    {t(financialAuthCancelled ? 'order-fuel.cancelOrderSuccess' : 'order-fuel.thanksForOrdering')}
                                </div>
                            </div>
                            {financialAuthSent ? (
                                <div className='col-12 font-14-500'>
                                    <span className='flex-inputs'>{t('order-fuel.financialAuthSent')}</span>
                                </div>
                            ) : null}
                            <div className='col-12 font-14-500  order-number-row'>
                                <span className='flex-inputs'>{t('order-fuel.orderNumber')}</span>
                                <span className='flex-inputs bold'>{orderNumber}</span>
                            </div>
                            <div className='col-12 font-14-500 redirect'>
                                <span className='flex-inputs'>{t('order-fuel.redirect')}</span>
                            </div>
                        </div>
                    )
                ) : (
                    <div className='row font-14-500'>{t('error.addOrderFuelError')}</div>
                )}
            </React.Fragment>
        );
    }
}

OrderFuelConfirmationDialog.defaultProps = {};

OrderFuelConfirmationDialog.propTypes = {
    orderNumber: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    backUrl: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string,
};

export default withTranslation()(OrderFuelConfirmationDialog);
